<template>
<div id="text-input-v1-scwxlc">
    <b-form-group id="text-input-v1-szu12k" v-if="showType == 'form-builder'" :description="properties.description" :label="properties.label" :style="properties.style">
      <b-form-input id="text-input-v1-digd58" :placeholder="properties.placeholder"></b-form-input>
    </b-form-group>
    <div id="text-input-v1-xasacn" v-if="showType == 'properties'">
      <text-input-v1-properties id="text-input-v1-2h3nrj" :formId="formId"></text-input-v1-properties>
    </div>
    <b-form-group id="text-input-v1-ubjdd5" style="font-size: 14px" v-if="
        (showType == 'form-submitter' && page == currentPage) ||
          (showType == 'e-form' && properties.eFormEditable)
      " :description="
        computedConditions.description
        ?
         computedPropertiesForm.description 
         : properties.description
      " :style="properties.style" v-show="!computedHidden" :state="state" :invalid-feedback="errors.join(', ')">
      <template v-slot:label>
        <div id="text-input-v1-fsmxj9" class="d-flex justify-content-between align-items-center">
          <div id="text-input-v1-s73rw7">
            {{ computedConditions.label
            ? computedPropertiesForm.label
            : properties.label }}
          </div>
          <div id="text-input-v1-9u37do" v-if="config.serverSegment == 'core'">
            <b-dropdown id="text-input-v1-90dzxf" text variant="link" size="sm" no-caret ref="responsesDropdown" boundary="viewport" right @show="getSavedResponses">
              <template #button-content>
                <i id="text-input-v1-x7e5bl" class="fas fa-ellipsis-v text-secondary"></i>
              </template>
              <b-dropdown-form id="text-input-v1-gzgl5m">
                <div id="text-input-v1-b0oj7m" v-if="currentFormId != 'previewForm'" class="dropdown-item hover-pointer" :disabled="!localValue" style="font-size: 14px;" @click="saveResponse"><i id="text-input-v1-xdqqsk" class="fas fa-save mr-2"></i>Save value</div>              
                <div id="text-input-v1-kjawp5" class="px-2" style="padding: 14px; font-size: 14px; background-color: #f4f7fb">
                  Load value:
                </div>
              </b-dropdown-form>
              <div class="dropdown-item hover-pointer" v-for="(s, i) in combinedResponses" :key="s.id" @click="writeResponse(s.response)" :id="'text-input-v1-ewobov-' + i">
                <div class="d-flex flex-row align-items-center justify-content-between" style="font-size: 14px;" :id="'text-input-v1-zm6l09-' + i">                  
                  <div class="mr-3" style="white-space: normal" :id="'text-input-v1-1hpqu9-' + i"><i class="fas fa-clone mr-2" :id="'text-input-v1-4ifazn-' + i"></i>{{ s.response }}</div>
                  <i class="fas fa-trash text-danger" :style="{ visibility: s.isPredefined ? 'hidden' : 'visible' }" @click.stop="deleteResponse(s.id)" :id="'text-input-v1-t98hxv-' + i"></i>
                </div>
              </div>
            </b-dropdown>
          </div>
        </div>
      </template>
      <b-form-input id="text-input-v1-o8jsaw" style="font-size: 14px" :placeholder="
          computedConditions.placeholder
            ? computedPropertiesForm.placeholder
            : properties.placeholder
        " :readonly="
          computedConditions.readonly
            ? computedPropertiesForm.readonly
            : properties.readonly
        " :required="
          computedConditions.required
            ? computedPropertiesForm.required
            : properties.required
        " v-model="localValue" @blur="controlValue = localValue" :state="state"></b-form-input>
    </b-form-group>
    <b-form-group id="text-input-v1-gf9727" v-if="
        showType == 'form-viewer' ||
          (showType == 'e-form' && !properties.eFormEditable)
      " :label="
        computedConditions.label
          ? computedPropertiesForm.label
          : properties.label
      ">
      {{ controlValue }}
    </b-form-group>
  </div>

</template>

<script>
import { mapGetters, mapMutations, mapState, mapActions } from "vuex";
import TextInputV1Properties from "./TextInputV1Properties.vue";
import savedResponseServer from "../../../../server/userResponse";
import config from "../../../../server/serverCfg";
import { getComponentBaseId } from "../../../../helpers/formBuilder";

export default {
  name: "TextInputV1",
  components: { TextInputV1Properties },
  props: ["showType", "properties", "form", "id", "results", "formId", "page", "componentsIdSuffix"],
  data() {
    return {
      computedProperties: [
        "description",
        "label",
        "hidden",
        "placeholder",
        "readonly",
        "required",
        "excludeFromLoadFromLastResult",
        "responseOptions"
      ],
      computedConditions: {},
      value: "",
      localValue: "",
      savedResponses: [],
      config: config,
      savedResponsesLoaded: false
    };
  },
  mounted() {
    this.computeConditions();
          this.localValue = this.controlValue;
      if (this.showType == "form-submitter" || this.showType == "e-form") {
        const baseId = getComponentBaseId(this.id);
        this.setFormSubmitterComponentMetadata({
          controlId: baseId,
          controlMetadata: {
            label: this.properties.label
          }
        });
        if(this.componentsIdSuffix) {
          this.initializeComponentValue({
            controlId: baseId,
            properties: this.properties
          });
        }
    }
  },
  methods: {
    ...mapMutations("formSubmitter", ["setFormSubmitterComponentMetadata"]),
    ...mapActions("formSubmitter", ["setFormSubmitterComponentValue", "computeFormSubmitterValue", "initializeComponentValue"]),
    computeConditions() {
      const computedConditions = {};
      for (let index = 0; index < this.computedProperties.length; index++) {
        const property = this.computedProperties[index];
        computedConditions[property] =
          typeof this.properties[property] == "string" &&
          this.properties[property].includes("{{");
      }
      this.computedConditions = computedConditions;
    },
    getComponentComputedProperties(property) {
      return this.computedPropertiesForm
        ? this.computedPropertiesForm[property] != null
          ? this.computedPropertiesForm[property]
          : this.properties[property]
          ? this.properties[property]
          : ""
        : this.properties[property]
        ? this.properties[property]
        : "";
    },
    getBakedLayout() {
      const hidden = this.getComponentComputedProperties(
        "hidden"
      );

      if(hidden === true)
        return "";
        
      return `
      <fieldset aria-describedby="" class="form-group" style="${this.getComponentComputedProperties(
        "style"
      )}">
        <legend style="font-size: 14px" tabindex="-1" class="bv-no-focus-ring col-form-label pt-0">${this.getComponentComputedProperties(
          "label"
        )}</legend>
        <div style="font-size: 14px" tabindex="-1" role="group" class="bv-no-focus-ring">
          ${this.controlValue || ""}
        </div>
      </fieldset>`;
    },
    async saveResponse(e) {
      if (this.currentFormId == "previewForm") return;
      e.stopPropagation()
      if(this.localValue.trim() && !this.combinedResponses.find(r => r.response.trim() == this.localValue.trim())) {
        await savedResponseServer.create({
          formId: this.currentFormId,
          componentId: this.id,
          response: this.localValue,
        });
        await this.getAllResponses();
        this.updatePopper();
      }
      
    },
    updatePopper() {
      this.$refs.responsesDropdown.updatePopper();
    },
    async deleteResponse(id){
      await savedResponseServer.delete(id);
      await this.getAllResponses();
      this.updatePopper();
    },
    async getAllResponses(){
      this.savedResponses = this.currentFormId == "previewForm" ? [] : await savedResponseServer.query(this.currentFormId, this.id);
    },
    writeResponse(response){
      this.controlValue = response;
    },
    async getSavedResponses() {
      if (!this.savedResponsesLoaded) {
        await this.getAllResponses();
        this.savedResponsesLoaded = true;
      }
    }
  },
  computed: {
    ...mapState("formSubmitter", {
      formErrors: state => state.form.errors,
      currentFormId: state => state.form.id,
      currentPage: state => state.form.currentPage
    }),
    ...mapGetters("formSubmitter", [
      "getFormSubmitterComponentValue"
    ]),
    computedPropertiesForm() {
      return this.$store.state.formSubmitter.form.computedProperties[this.id] ?? this.properties;
    },
    controlValue: {
      get() {
        const baseId = getComponentBaseId(this.id);
        if (this.results) return this.results[baseId];
        return this.getFormSubmitterComponentValue(baseId);
      },
      set(newControlValue) {
        if (this.controlValue != newControlValue) {
          const baseId = getComponentBaseId(this.id);
          this.setFormSubmitterComponentValue({
            controlId: baseId,
            controlValue: newControlValue,
            userAction: true
          });
          this.$emit("update-child-control-value", {
            controlId: baseId,
            controlValue: newControlValue
          });
          if (this.properties.onChange) {
            this.computeFormSubmitterValue({
              elementId: this.id,
              property: "onChange",
              value: `computed:(${this.properties.onChange})(${JSON.stringify(
                newControlValue
              )})`,
              defaultValue: null,
              form: this.form,
              statements: true
            });
          }
        }
      }
    },
    errors: {
      get() {
        const errorId = getComponentBaseId(this.id, this.formErrors);
        return this.formErrors[errorId] ? this.formErrors[errorId] : [];
      }
    },
    state: {
      get() {
        return this.errors.length == 0 ? null : false;
      }
    },
    computedHidden(){
      const hiddenValue = this.computedConditions.hidden
        ? this.computedPropertiesForm.hidden
        : this.properties.hidden

      this.$emit("change-hidden-property", hiddenValue);
      return hiddenValue;
    },
    predefinedOptions() {
      const responseOptions = this.computedConditions.responseOptions
        ? this.computedPropertiesForm.responseOptions
        : this.properties.responseOptions;
      return responseOptions;  
    },
    combinedResponses(){
      const predefinedOptions = this.predefinedOptions ?? [];
      return predefinedOptions.map(p => ({
          response: p,
          isPredefined: true
        })).concat(this.savedResponses);
    }
  },
  watch: {
    controlValue(newValue) {
      if (newValue != this.localValue) {
        this.localValue = newValue;
      }
    }
  }
};
</script>

<style scoped>
>>> .dropdown-menu {
  width: max-content;
  max-height: 300px;
  max-width: 500px;
  overflow-y: auto;
}

>>> .dropdown-item {
  padding: 0.25rem 0.5rem;
}
</style>
